import { createReducer } from 'typesafe-actions';

import {
  disconnectWallet,
  setActiveWalletAndKey,
  setActiveWalletName,
} from './actions';
import { WalletType } from './types';

type State = {
  activeWalletType: WalletType | null;
  activeWalletName: string;
  activePublicKey: string | null;
};

const initialState: State = {
  activeWalletType: null,
  activeWalletName: '',
  activePublicKey: null,
};

export default createReducer(initialState)
  .handleAction(
    setActiveWalletAndKey,
    (state, { payload: { walletType, publicKey } }): State => ({
      ...state,
      activeWalletType: walletType,
      activePublicKey: publicKey,
    })
  )
  .handleAction(
    setActiveWalletName,
    (state, { payload: { walletName } }): State => ({
      ...state,
      activeWalletName: walletName,
    })
  )
  .handleAction(
    disconnectWallet,
    (state, { payload }): State => ({
      ...state,
      activeWalletType: null,
      activeWalletName: '',
      activePublicKey: null,
    })
  );
